<template>
<div>
  <h3>Proporcione los datos del grupo de clientes</h3>
  <v-form ref="clienteForm">
    <v-row>
      <v-col cols="12" md="12">
        <v-text-field
          v-model="GrupoCliente.Nombre"
          :rules="Rules.Nombres"
          label="Grupo de clientes"
          outlined
          dense
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn
        style="margin-left: 6px"
        color="success"
        large
        @click="checkForm()"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</div>
</template>
<script>
import moment from "moment";
import GruposClientes from "../../../clases/Clientes/GruposClientes.js"
export default {
  name: "GruposClientesForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
       menu: false,
      GrupoCliente: GruposClientes.getPropertyModel(),
      Rules: GruposClientes.getRules(),
      errors: {},
      loader: true,
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.clienteForm.validate()) {
        
          this.createGrupoClient(this.GrupoCliente);
      
      }
    },
    createGrupoClient(dataCliente) {
      let dataSend = {
        gps:[this.GrupoCliente.Nombre]
      }
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"el grupo de clientes",
          route:'PDV-GruposClientes-addGruposCliente',
          data:dataSend,
          onSuccess:()=>{
            this.$emit('toggle', false)
            this.$emit('reload', false)
          }
        }
      );
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {
    this.loader = true;
  },
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.GrupoCliente = this.dataEdit;
      this.GrupoCliente.TelefonoAux = (this.GrupoCliente.Telefonos[0])?this.GrupoCliente.Telefonos[0]:""
    }else{
      this.GrupoCliente = new GruposClientes();
    }
  },
};
</script>
<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>